var map = {
	"./en-US/main.json": [
		9596,
		[
			946
		]
	],
	"./ja-JP/main.json": [
		628,
		[
			570
		]
	],
	"./zh-CN/main.json": [
		4762,
		[
			988
		]
	],
	"./zh-TW/main.json": [
		246,
		[
			764
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8726;
module.exports = webpackAsyncContext;